export const ArtistSectionTitle = ({
  children,
}: {
  children: React.ReactNode
}) => <div className="text-title-xs text-monochrome-1">{children}</div>
